// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"164":"public-checkout-pallet","203":"view-order","702":"pending-orders"}[chunkId] + "." + {"164":"3686f5b8","203":"3dbf40ba","702":"71c2c0ec"}[chunkId] + ".css";
};